import * as angular from 'angular';

import { ComponentDefinition, TagDefinition, IValueViewModel, ObjectType } from '../../models/index';
import { tagDefaultState, dateFormat } from '../../common/';
import { IIdentifierVmService, INavigationHistoryService } from '../../services/';

class IdentifierDetailsController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;
    identifierVM: IValueViewModel;
    viewModels: IValueViewModel;
    dateFormat = dateFormat;

    static $inject = [
        '$state',
        '$translate',
        'identifierVmService',
        'navigationHistoryService'
    ];

    constructor(
        private _$state: angular.ui.IStateService,
        private _$translate: angular.translate.ITranslateService,
        private _identifierVmService: IIdentifierVmService,
        private _navigationHistoryService: INavigationHistoryService
    ) {
    }

    $onInit() {
        if (!this.viewModels) {
            const identifierGuid = this._$state.params.identifierGuid;
            if (identifierGuid) {
                this.isLoading = true;
                this._identifierVmService.getViewModelFromApi(identifierGuid, ObjectType.Identifier)
                    .then(identifierVm => {
                        this.identifierVM = identifierVm;
                        this.updateName(identifierVm.name);
                    })
                    .finally(() => this.isLoading = false);
            }
        } else {
            this.identifierVM = this.viewModels;
            this.updateName(this.viewModels.name);
        }
    }

    gotoStateTag(tag: TagDefinition, $event: angular.IAngularEvent) {
        if (tag) {
            this._$state.go(tagDefaultState, { tagDefinitionGuid: tag.guid });
            $event.preventDefault();
        }
    }

    private updateName(name: string) {
        const translated = `${this._$translate.instant(this._$state.current.data.displayName)} - ${name}`;
        this._navigationHistoryService.updateLastHistory(translated, 'calculated.');
        this._navigationHistoryService.updateLastHistory(translated, 'validated.');
    }
}

export const wtIdentifierDetails: ComponentDefinition = {
    componentId: 'wtIdentifierDetails',
    controller: IdentifierDetailsController,
    template: require('./identifierDetails.component.html'),
    controllerAs: 'vm',
    bindings: {
        viewModels: '='
    }
};
